import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import {
  DateField,
  // ExpireField
} from '../../components/fields'
import { COMMON_FIELDS, PROMOTIONS_FIELDS } from '../../providers/localization/constant'

const PromotionsListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${PROMOTIONS_FIELDS}.name`)}
    // />,
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${PROMOTIONS_FIELDS}.title`)}
    />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.published.label`}
      source='is_published'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
        { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
      ]}
    />,
    <SelectInput
      key={4}
      label={`${COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]
}

const PromotionsList = (): JSX.Element => {
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={PromotionsListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='show'>
        {/* <TextField source='order' label={`${COMMON_FIELDS}.order`} textAlign='center' /> */}
        <TextField
          source='title_th'
          label={`${PROMOTIONS_FIELDS}.title_th`}
          sortable={false}
        ></TextField>
        <TextField
          source='title_en'
          label={`${PROMOTIONS_FIELDS}.title_en`}
          sortable={false}
        ></TextField>
        {/* <TextField source='description_th'  label={`${PROMOTIONS_FIELDS}.description_th`}></TextField>
        <TextField source='description_en'  label={`${PROMOTIONS_FIELDS}.description_en`}></TextField>
        <TextField source='short_description_th'  label={`${PROMOTIONS_FIELDS}.short_description_th`}></TextField>
        <TextField source='short_description_en'  label={`${PROMOTIONS_FIELDS}.short_description_en`}></TextField> */}
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        {/* <ExpireField label={`${COMMON_FIELDS}.expired.label`} textAlign='center' /> */}
        <DateField source='start_date' label={`${PROMOTIONS_FIELDS}.start`} textAlign='center' />
        <DateField source='end_date' label={`${PROMOTIONS_FIELDS}.end`} textAlign='center' />
        <BooleanField
          source='is_max_card'
          label={`${PROMOTIONS_FIELDS}.max_card.label`}
          textAlign='center'
          sortable={false}
        />
        <BooleanField
          source='is_credit_card'
          label={`${PROMOTIONS_FIELDS}.credit_card.label`}
          textAlign='center'
          sortable={false}
        />
        {/* <BooleanField
          source='is_approved'
          label={`${COMMON_FIELDS}.approved.label`}
          textAlign='center'
          sortable={false}
        /> */}
        <BooleanField
          source='is_published'
          label={`${COMMON_FIELDS}.published.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default PromotionsList
